import React, { Component } from 'react';
import config from 'config/api';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
const styles = (theme) => {
  return {
    root: {
      paddingBottom: theme.spacing(2),
      textAlign: 'center',
      '& .MuiTypography-body1': {
        margin: '0 5px',
      },
      '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
    gold: {
      color: theme.palette.primary.main,
    },
    legal: {
      maxWidth: 800,
      margin: '20px auto',
      padding: '10px 20px',
      textAlign: 'left',
    },
    social: {
      width: 20,
      height: 20,
      display: 'inline-block',
      verticalAlign: 'middle',
      margin: '0 5px 0 0',
      '& img': {
        width: '100%',
        height: '100%',
      },
    },
  };
};

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLegal: false,
    };
  }
  componentDidMount() { }
  _legalToggle(e) {
    e.preventDefault();
    this.setState({ showLegal: !this.state.showLegal }, function () {
      const top = document.getElementById('Footer') ? document.getElementById('Footer').offsetTop : false;
      window.scroll({
        top,
        behavior: 'smooth',
      });
    });
  }
  render() {
    const { classes } = this.props;
    const { showLegal } = this.state;
    const ml = 'contact__lobster-fr*com'.replace('__', '@').replace('*', '.');
    const mlt = ('mail::to:' + ml).replace('::', '');
    return (
      <div className={classes.root} id="Footer">
        <Grid container spacing={0}>
          <Grid item container xs={12} sm={12} justify="center" alignItems="center">
            <Typography variant="body1" gutterBottom>
              <span>
                Lobst<em className={classes.gold}>e</em>r
              </span>{' '}
              <em className="dash">-</em> <em className={classes.gold}>140 bis rue de Rennes 75006 PARIS</em>
            </Typography>
            <Typography variant="body1" gutterBottom>
              <span>01 59 51 07 02</span>
              &nbsp;
              <span>
                <a className={classes.gold} href={mlt}>
                  {ml}
                </a>
              </span>
              &nbsp;
            </Typography>
            <Typography variant="body1" gutterBottom>
              <a className={classes.social} href={config.fb} target="_blank">
                <img src={require('@assets/images/icon_facebook.jpg')} alt="Facebook" />
              </a>
              <a className={classes.social} href={config.ld} target="_blank">
                <img src={require('@assets/images/icon_linkedin.jpg')} alt="Linkedin" />
              </a>
            </Typography>
          </Grid>

          <Grid item container xs={12} sm={12} justify="center" alignItems="center">
            <Link to={'/confidentialite'} className={classes.gold}>
              Politique de Confidentialité
            </Link>{' '}
            &nbsp;-&nbsp;
            <a className={classes.gold} onClick={this._legalToggle.bind(this)}>
              Mentions Légales
            </a>
          </Grid>

          <Grid container item xs={12} justify="center" alignItems="center">
            <If condition={showLegal}>
              <div className={classes.legal}>
                <span className="title">MENTIONS LEGALES</span>
                lobster-fr.com est édité par la société Lobster
                <span className="spacer"></span>
                <div className="dualTable">
                  <span className="left">
                    Lobster
                    <br />
                    <br />
                    Société lobster
                    <br />
                    140 bis rue de Rennes 75006 PARIS
                    <br />
                    SARL au capital de 50 000 €<br />
                    RCS Nanterre 520 504 614
                    <br />
                    APE 7022Z
                    <br />
                    TVA FR 94520504614
                  </span>
                  <span className="right">
                    Hébergeur
                    <br />
                    <br />
                    Ce site est hébergé par OVH
                    <br />2 rue kellermann BP 80157 - 59053 Roubaix Cedex 1 - France
                    <br />
                    SAS au capital de 10 059 500 € <br />
                    RCS Lille 424 761 419
                    <br />
                    APE 2620Z <br />
                    TVA FR22424761419
                  </span>
                </div>
                <p>
                  Tél. : 01 59 51 07 02 - Mail : <a href={mlt}>{ml}</a> - Représentants Légaux : Dimitri
                  Morlet, Cyril Eaton - Directeur de la Publication : Dimitri Morlet
                </p>
                <span className="spacer"></span>
                <p>
                  <strong>Confidentialité et Protection des Données</strong>
                  <br />
                  <br />
                  Les sites de la société Lobster sont enregistrés auprès de la Commission Nationale de
                  l'Informatique et des Libertés. Conformément à la loi informatique et libertés du 06 janvier
                  1978, vous pouvez à tout moment modifier ou supprimer les renseignements liés à votre
                  inscription. Ces informations vous concernant étant confidentielles, Lobster s'engage à les
                  protéger.
                  <br />
                  Vous disposez d'un droit d'accès, de modification, de rectification et de suppression des
                  données qui vous concernent (art. 34 de la loi "Informatique et Libertés").
                  <br />
                  Vous pouvez exercer ce droit en nous contactant par mail ou par téléphone.
                  <br />
                  Pour plus d'informations, vous pouvez consulter le site de la CNIL : http://www.cnil.fr
                </p>
              </div>
            </If>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.jsx